import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { getAlbumPath } from 'reactApp/modules/albums/albums.selector';
import { isAlbum } from 'reactApp/modules/albums/albums.types';
import { getAttachUrl } from 'reactApp/modules/attaches/attaches.helpers';
import { isPublicAlbumTemporaryUrl } from 'reactApp/modules/public/publicAlbum.helper.store';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { store } from 'reactApp/store';
import { getEncodePath } from 'reactApp/utils/urlHelper';

import type { ContextMenuItem } from './ContextMenu';

const getId = (item, storage: EStorageType) => {
    const { isStock, isPublic } = getStorage(storage);

    const id = item.id?.replace('/', '');

    if (isPublic) {
        return `/${item.weblink}`;
    }

    if (isStock) {
        return item.id;
    }

    return encodeURIComponent(id);
};

// eslint-disable-next-line complexity
export const getPathToNewTab = (item, storage, userEmail: string | null): string => {
    const {
        isHome,
        isSharedIncoming,
        isSearch,
        isSharedLinks,
        isSharedAutodelete,
        isFeed,
        isDocuments,
        isStart,
        isFavorites,
        isAttaches,
        isAlbums,
        isAllDocuments,
        isIncomingPublic,
        isFamilyFolders,
        isFamilyAlbums,
        isVigbo,
    } = getStorage(storage);

    const id = getId(item, storage);

    if (
        isHome ||
        isSharedIncoming ||
        isSearch ||
        isSharedLinks ||
        isSharedAutodelete ||
        isFeed ||
        isDocuments ||
        isAllDocuments ||
        isStart ||
        (isFavorites && item.ext && item.ext.toLowerCase() === 'pdf') ||
        (isFavorites && item.isFolder) ||
        isFamilyFolders
    ) {
        return `home${getEncodePath(item.home) || ''}`;
    }

    if (isAttaches) {
        return getAttachUrl(item.id, userEmail, true);
    }

    if (isAlbums) {
        return isAlbum(item)
            ? `${storage}/${getAlbumPath(store.getState(), id)}`
            : `${storage}/${getAlbumPath(store.getState(), item.parent)}/${id}`;
    }

    if (isFamilyAlbums) {
        return `albums/custom/${id}`;
    }

    const isAlbumLocation = isPublicAlbumTemporaryUrl();

    if (isAlbumLocation) {
        return `album${id}`;
    }

    if (isIncomingPublic) {
        return `public/${item.weblink}`;
    }

    if (isVigbo) {
        return `vigbo/${item.parent === ROOT_FOLDER_ID ? '' : `${item.parent}/`}${id}`;
    }

    return `${storage}/${id}`;
};

export const makeFlatDividedList = (groups: ContextMenuItem[][]) =>
    groups.reduce((acc, group) => {
        const clonedGroup = group.slice();

        if (clonedGroup.length > 0) {
            const lastIndex = clonedGroup.length - 1;

            clonedGroup[lastIndex] = {
                ...clonedGroup[lastIndex],
                divider: true,
            };
        }

        acc.push(...clonedGroup);

        return acc;
    }, []);
